// extracted by mini-css-extract-plugin
export default {"whiteBoard":"whiteBoard_whiteBoard__Id1+k","icon":"whiteBoard_icon__e7lzm"};